<template>
  <v-btn
    v-bind="activatorProps"
    :icon="iconName"
    size="30"
    :text="title"
    class="ma-1"
    variant="outlined"
    @click="isActive = true"
  ></v-btn>
  <v-dialog max-width="900" v-model="isActive">
    <v-card :title="title">
      <v-sheet class="mx-auto" width="300">
        <v-form @submit.prevent enctype="multipart/form-data" ref="form">
          <v-text-field
            type="number"
            v-model="formData._value"
            :rules="[
              item._key == 'pay_day' || item._key == 'cut_day'
                ? valueRules.days
                : valueRules.money,
            ]"
            label="القيمة"
          ></v-text-field>
        </v-form>
      </v-sheet>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text="حفظ" @click="save"></v-btn>

        <v-btn text="إغلاق" @click="close"></v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ["saveFunction", "item", "mode", "iconName"],
  data() {
    return {
      isActive: false,
      formData: {
        _value: "",
      },
      valueRules: {
        days: (v) => (v && v <= 7 && v >= 1) || "exceeded",

        money: (v) => (v && v <= 999000 && v >= 1) || "exceeded",
      },
    };
  },
  methods: {
    async validate() {
      const { valid } = await this.$refs.form.validate();

      if (valid) alert("Form is valid");
    },
    reset() {
      this.$refs.form.reset();
    },
    async save() {
      const { valid } = await this.$refs.form.validate();

      if (valid) {
        this.saveFunction(this.formData, this.mode);

        this.isActive = false;
      }
    },
    close() {
      this.isActive = false;
    },
  },
  watch: {
    isActive(value) {
      if (value) {
        if (this.mode == "edit") {
          this.formData = { ...this.item };
        }
      }
    },
  },
  computed: {
    title() {
      if (this.mode == "add") return "إضافة إعداد";
      return "تعديل إعداد";
    },
  },
};
</script>
